const CLIENT_PRE = 'pre'
const CLIENT_POS_CTRL = 'pos_controle'
const CLIENT_POS = 'pos_pago'

export default {
  CLIENT_PRE,
  CLIENT_POS_CTRL,
  CLIENT_POS
}
